<template>
  <div class="preloader" :class="{closed: !show}">
    <div class="loader">
      <div class="line"></div>
      <div class="line"></div>
      <div class="line"></div>
      <div class="line"></div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'loading',

  props: ['show'],

}
</script>


<style scoped>


.line {
  animation: expand 1s ease-in-out infinite;
  border-radius: 10px;
  display: inline-block;
  transform-origin: center center;
  margin: 0 7px;
  width: 10px;
  height: 50px;
}

.line:nth-child(1) {
  background: #27ae60;
}

.line:nth-child(2) {
  animation-delay: 180ms;
  background: #f1c40f;
}

.line:nth-child(3) {
  animation-delay: 360ms;
  background: #e67e22;
}

.line:nth-child(4) {
  animation-delay: 540ms;
  background: #2980b9;
}

@keyframes expand {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(2);
  }
}

.preloader {
  align-items: center;
  background: #0F1723;
  /* background: transparent; */
  display: flex;
  height: 100vh;
  justify-content: center;
  right: 0;
  position: fixed;
  bottom: 0;
  transition: opacity 0.3s linear;
  width: 100%;
  z-index: 99999999;
  color: #fff;

  transition-property: all;
	transition-duration: 0.5s;
	transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}
.preloader.closed {
	/* height: 0; */
  width: 0;
}

.preloader.closed .loader {
	display: none;
}

</style>